import { Pipe, PipeTransform } from "@angular/core";

type NumberDurationForms = [string, string] | [string, string, string | null];

@Pipe({
    name: "durationFormat",
    standalone: false,
})
export class DurationFormatPipe implements PipeTransform {

    transform(value: string): string {
        if (!value) return "";

        const [daysStr, hoursStr, minutesStr] = value.split(":");
        const days = parseInt(daysStr, 10);
        const hours = parseInt(hoursStr, 10);
        const minutes = parseInt(minutesStr, 10);

        const duration = { days, hours, minutes };

        return this.formatDuration(duration);
    }

    private formatDuration(duration: { days?: number; hours?: number; minutes?: number; seconds?: number }, locale: string = 'en-US'): string {   // TODO [4ref] - Add multilingual variability
        if ('DurationFormat' in Intl) {
            const formatter = new (Intl as any).DurationFormat(locale, { style: 'long' });
            return formatter.format(duration);
        } else {
            return this.formatDurationFallback(duration, locale);
        }
    }
    
    formatDurationFallback(duration: { days?: number; hours?: number; minutes?: number; seconds?: number; }, locale: string): string {
        if(typeof duration.days == 'undefined') { duration.days = 0; }
        if(typeof duration.hours == 'undefined' || typeof duration.minutes == 'undefined') {
            throw new Error("Method not implemented.");
        }
        else {
            const period_in_days: NumberDurationForms = ["day", "days"];  // TODO [4ref] - Add multilingual variability
            // const period_in_days: NumberDurationForms = ["dag", "dage"];
            const period_in_hours: NumberDurationForms = ["hour", "hours"];  // TODO [4ref] - Add multilingual variability
            // const period_in_hours: NumberDurationForms = ["time", "timer"];
            const period_in_minutes: NumberDurationForms = ["minute", "minutes"];  // TODO [4ref] - Add multilingual variability
            // const period_in_minutes: NumberDurationForms = ["minut", "minutter"];

            const parts: string[] = [];
            if (duration.days > 0) {
                parts.push(`${duration.days} ${this.pluralize(duration.days, period_in_days)}`);
            }
            if (duration.hours > 0) {
                parts.push(`${duration.hours} ${this.pluralize(duration.hours, period_in_hours)}`);
            }
            if (duration.minutes > 0) {
                parts.push(
                    `${duration.minutes} ${this.pluralize(duration.minutes, period_in_minutes)}`
                );
            }
            return parts.join(", ");
        }
    }

    private pluralize(n: number, forms: NumberDurationForms): string {
        const [one, many, maybeFew] =
            forms.length === 3 ? forms : [forms[0], forms[1], null];

        if (maybeFew == null || !maybeFew) {
            return n === 1 ? one : many;
        } else {
            const mod10 = n % 10;
            const mod100 = n % 100;

            if (mod10 === 1 && mod100 !== 11) return one;
            if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20))
                return maybeFew;
            return many;
        }
    }
}
